module.exports = __webpack_public_path__ + "img/banner.bf76502a.png";